import React from 'react'

export default function TermsOfService() {
  return (
    <div>
      <h1>Terms Of Service page</h1>
    </div>
  )
}
